import { Component, EventEmitter, Input, Output } from '@angular/core';
import { faCheck, faTrash } from '@fortawesome/free-solid-svg-icons';
import { faPen } from '@fortawesome/free-solid-svg-icons';
import { map, Observable } from 'rxjs';
import { ChassisTimeTableModel } from 'src/app/models/ChassisTimeTable';
import { ChassisService } from 'src/app/services/chassis/chassis.service';

@Component({
  selector: 'app-chassis-time-table',
  templateUrl: './chassis-time-table.component.html',
  styleUrl: './chassis-time-table.component.css'
})
export class ChassisTimeTableComponent {

  faTrash = faTrash
  faPen = faPen
  faCheck = faCheck

  @Input() mode: 'selection' | 'edit' = 'edit';
  @Input() toggle: boolean = false;

  @Output() toggleChange = new EventEmitter<boolean>();
  @Output() rowSelected = new EventEmitter<any>();

  tripToEdit!: ChassisTimeTableModel | null;
  data$ = new Observable<ChassisTimeTableModel[]>()

  isLoading: boolean = false;
  showForm: boolean = false

  constructor(private chassisService: ChassisService) {
  }

  ngOnInit() {
    this.loadChassisTimeTable()
  }

  loadChassisTimeTable() {
    this.isLoading = true
    this.data$ = this.chassisService.getAllTrips()
    this.isLoading = false;
  }

  deleteTrip(tripId: number, tripName: string) {
    if (confirm(`Deseja realmente excluir a viagem: ${tripName}?`)) {
      this.chassisService.deleteTrip(tripId).subscribe({
        next: _ => {
          alert("Viagem excluída com sucesso");
          this.data$ = this.data$.pipe(
            map(response => response.filter(r => r.id !== tripId)));
        },
        error: _ => {
          alert("Erro ao excluir a viagem");
        },
      });
    }
  }

  openEditForm(trip: any) {
    this.showForm = true
    this.tripToEdit = trip
  }

  onToggleClick(event: MouseEvent) {
    event.stopPropagation();
    this.toggleChange.emit(false);
    this.toggle = !this.toggle;
  }

  toggleForm() {
    this.showForm = !this.showForm
    if (!this.showForm) {
      this.tripToEdit = null
    }
  }

  onSelectRow(data: any, event: MouseEvent) {
    event.stopPropagation();
    this.rowSelected.emit(data);
    this.toggle = !this.toggle
  }

  onDataUpdated() {
    this.loadChassisTimeTable()
    this.showForm = false
    this.tripToEdit = null
  }
}
